import { RouterModule, Routes } from '@angular/router';
import {ParametersComponent} from './parameters/parameters.component';
import { LayoutComponent } from './layout/layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
// Page Layouts
import { PageLayoutFullscreenComponent } from './page-layouts/fullscreen/fullscreen.component';
import {SearchComponent} from './search/search.component';


const AppRoutes: Routes = [
    { path: '', redirectTo: '/app/documents', pathMatch: 'full' },
    { path: 'app', component: LayoutComponent },
    { path: 'extra', loadChildren: './extra-pages/extra-pages.module#ExtraPagesModule' },
    { path: 'fullscreen', component: PageLayoutFullscreenComponent },
    { path: '**', redirectTo: '/app/documents', pathMatch: 'full' },
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, {useHash: true});



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app-routing.module.ts